@switch (color) {
  @case ('grey') {
    <span
      class="inline-flex items-center rounded-full bg-surface-hover px-2 py-1 text-xs font-medium text-fg-muted ring-1 ring-inset ring-outline/20 whitespace-nowrap"
      >{{ displayName }}</span
    >
  }
  @case ('red') {
    <span
      class="inline-flex items-center rounded-full bg-red-50 px-2 py-1 text-xs font-medium text-red-700 ring-1 ring-inset ring-red-600/10 whitespace-nowrap"
      >{{ displayName }}</span
    >
  }
  @case ('yellow') {
    <span
      class="inline-flex items-center rounded-full bg-yellow-50 px-2 py-1 text-xs font-medium text-yellow-800 ring-1 ring-inset ring-yellow-600/20 whitespace-nowrap"
      >{{ displayName }}</span
    >
  }
  @case ('green') {
    <span
      class="inline-flex items-center rounded-full bg-green-50 px-2 py-1 text-xs font-medium text-green-700 ring-1 ring-inset ring-green-600/20 whitespace-nowrap"
      >{{ displayName }}</span
    >
  }
  @case ('blue') {
    <span
      class="inline-flex items-center rounded-full bg-blue-50 px-2 py-1 text-xs font-medium text-blue-700 ring-1 ring-inset ring-blue-700/10 whitespace-nowrap"
      >{{ displayName }}</span
    >
  }
  @case ('indigo') {
    <span
      class="inline-flex items-center rounded-full bg-blue-50 px-2 py-1 text-xs font-medium text-blue-700 ring-1 ring-inset ring-blue-700/10 whitespace-nowrap"
      >{{ displayName }}</span
    >
  }
  @case ('purple') {
    <span
      class="inline-flex items-center rounded-full bg-purple-50 px-2 py-1 text-xs font-medium text-purple-700 ring-1 ring-inset ring-purple-700/10 whitespace-nowrap"
      >{{ displayName }}</span
    >
  }
  @case ('pink') {
    <span
      class="inline-flex items-center rounded-full bg-pink-50 px-2 py-1 text-xs font-medium text-pink-700 ring-1 ring-inset ring-pink-700/10 whitespace-nowrap"
      >{{ displayName }}</span
    >
  }
}
